export default {
  FUTURE_ID: 1,
  PAST_ID: 2,
};
